import { render, staticRenderFns } from "./TabLocationInfo.vue?vue&type=template&id=5fc4b618&scoped=true&"
import script from "./TabLocationInfo.vue?vue&type=script&lang=js&"
export * from "./TabLocationInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabLocationInfo.vue?vue&type=style&index=0&id=5fc4b618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4b618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
